import { BasicLayout, EmptyLayout } from "@/layouts";

// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  "online-form": BasicLayout,
  "online-table": BasicLayout,
  dynamic: EmptyLayout,
  "enterprise-list": BasicLayout,
  "enterprise-info": BasicLayout,
  list: () => import("@/views/desForm/desForm.vue"),
  "enteprise-detail": () =>
    import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  "security-info": () =>
    import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  "environmental-info": () =>
    import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  "enterprise-doc": () =>
    import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  "manage-rule": () =>
    import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  "project-do": () => import("@/views/enterpriseDetails/enterpriseDetails.vue"),
  emergencyIndex: () => import("@/views/desForm/desForm.vue"),
  "dynamic-forms": () => import("@/views/desForm/desForm.vue"),
  main: () => import("@/views/desForm/desForm.vue"),
  iframe: () => import("@/views/iframe/iframe.vue"),
};

export default constantRouterComponents;
